<div class="page-body">
  <div *ngIf="loading">
    <app-spinner [infoText]="autoClosingMessage"></app-spinner>
  </div>

  <div *ngIf="!loading && showContent" class="contents-wrapper">
    <div class="contents-container">
      <div class="success-icon-container">
        <app-zaver-icon [size]="88" name="diamond"></app-zaver-icon>
      </div>

      <div class="success-message">{{ title }}</div>
      <div class="info-message">
        {{ settlementMessage }}
      </div>

      <div class="details-list-wrapper smallest-mobile-hide">
        <hr class="details-divider" *ngIf="amount" />
        <div class="details-container" *ngIf="amount">
          <div class="details-key-entry">Totalbelopp</div>

          <div class="details-value-entry" *ngIf="amount">
            {{
              amount.toLocaleString('sv', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })
            }}
            {{ currencyCode }}
          </div>
        </div>

        <hr class="details-divider" *ngIf="paymentMethod" />
        <div class="details-container" *ngIf="paymentMethod">
          <div class="details-key-entry">Betalsätt</div>

          <div class="details-value-entry">
            {{ paymentMethod }}
          </div>
        </div>

        <hr class="details-divider" *ngIf="paymentMethod || amount" />
      </div>

      <div class="buttons-mobile">
        <div class="app-button" (click)="openTab(APP_STORE_LINK)">
          <app-zaver-icon class="apple-logo" override="dark" [size]="16" name="appleLogo" ></app-zaver-icon>
          App Store
        </div>

        <div class="app-button" (click)="openTab(PLAY_STORE_LINK)">
          <app-zaver-icon class="google-logo" override="dark" [size]="16" name="googleStore" ></app-zaver-icon>
          Google Play
        </div>
      </div>

      <div *ngIf="waitingForRedirect && !successUrl">
        <zaver-loading-dots [color]="'#b7bcc8'"></zaver-loading-dots>
      </div>
      <div class="redirect" *ngIf="successUrl">
        <p *ngIf="noResponseMessage" class="no-response-message">
          {{ noResponseMessage }}
        </p>
        <zaver-primary-button
          text="Fortsätt"
          (click)="navigateToMerchant()"
        ></zaver-primary-button>
      </div>
    </div>
  </div>
</div>
